(function () {
    'use strict';

    angular.module("imApp").factory("batchDelPurchLinesBsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 299,
                    parameters: parms || {}
                });
            },
            listBatchPurchaseLines: function (parms) {
                return $ihttp.post({
                    method: 288,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 291,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
